import ClaimsTabContainer from 'Pages/Policy/components/ClaimsTab/ClaimsTabContainer';

export default ClaimsTabContainer;
